export * from './privacy-policy-page.component';
